'use client';

// npm packages
import React, { useEffect, useState } from 'react';

// components
import { cn } from '@/utils/cn';
import Badge from '../Badge';
import Icon from '../Icon';
import StoreLocatorCardBody from '../StoreLocator/StoreLocatorCardBody';

function StoreShowsOnMapModal({
  data,
  onView,
  onClose,
  className = '',
  fromStoreDetails,
}) {
  const [specificCardData, setSpecificCardData] = useState({});
  const [openModal, setOpenModal] = useState(onView);

  useEffect(() => {
    setSpecificCardData(data);
  }, [data]);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
      }, 500);
    } else {
      setOpenModal(false);
    }
  }, [onView]);

  const handleClose = () => {
    setOpenModal(false);
    setTimeout(() => {
      onClose(false);
    }, 200);
  };

  return (
    <div
      className={cn(
        `invisible w-full h-full bg-black/30 flex justify-center items-start opacity-0 z-[501] transition-all duration-300`,
        className,
        openModal && '!opacity-100 !visible',
      )}
    >
      <div
        className={cn(
          `w-full max-w-[542px] mx-8 px-16 sm:px-24  rounded-[4px] sm:rounded-[12px] transition-all duration-[400ms]`,
        )}
      >
        <div className="mb-12 mt-[60px]">
          <Icon
            type="close"
            color="#fff"
            onClick={handleClose}
            className="cursor-pointer ml-auto"
          />
        </div>
        <div className="bg-white px-16 pt-36 pb-16 rounded-xl relative shadow-cannot-be-added-modal">
          <div className="absolute top-0 left-0">
            <Badge
              type="store-locator"
              typeOfBadge={specificCardData?.store_type}
            />
          </div>
          <StoreLocatorCardBody item={specificCardData} fromStoreDetails />
        </div>
      </div>
    </div>
  );
}

export default StoreShowsOnMapModal;
